import React from "react";
import { useTranslation } from "react-i18next";

function PostJobPage(props)
{
    var { t } = useTranslation();

    return (
        <div className="uk-container uk-margin-large-top uk-margin-large-bottom uk-flex uk-flex-center">
            <div className="uk-card uk-card-default uk-card-body uk-box-shadow-medium uk-width-2-3@m">
                <h2 className="uk-card-title uk-text-center">{t("Post a Job")}</h2>

                <form className="uk-form-stacked uk-grid-small" uk-grid="true">
                    {/* Job title */}
                    <div className="uk-width-1-1">
                        <label className="uk-form-label">{t("Job Title")}</label>
                        <div className="uk-form-controls">
                            <input className="uk-input" type="text" placeholder={t("Enter job title")} />
                        </div>
                    </div>

                    {/* Job description */}
                    <div className="uk-width-1-1">
                        <label className="uk-form-label">{t("Description")}</label>
                        <div className="uk-form-controls">
                            <textarea className="uk-textarea" rows="4" placeholder={t("Enter job description")}></textarea>
                        </div>
                    </div>

                    {/* Photo upload */}
                    <div className="uk-width-1-1">
                        <label className="uk-form-label">{t("Add Photo")}</label>
                        <div className="uk-form-controls">
                            <div uk-form-custom="target: true">
                                <input type="file" />
                                <input className="uk-input uk-form-width-medium" type="text" placeholder={t("Select file")} disabled />
                            </div>
                        </div>
                    </div>

                    {/* Education level */}
                    <div className="uk-width-1-2@m">
                        <label className="uk-form-label">{t("Minimum Education")}</label>
                        <div className="uk-form-controls">
                            <select className="uk-select">
                                <option>{t("School")}</option>
                                <option>{t("University")}</option>
                            </select>
                        </div>
                    </div>

                    {/* Language requirements */}
                    <div className="uk-width-1-2@m">
                        <label className="uk-form-label">{t("Language Requirements")}</label>
                        <div className="uk-form-controls uk-form-controls-text">
                            <label><input className="uk-checkbox" type="checkbox" /> {t("Russian required")}</label><br/>
                            <label><input className="uk-checkbox" type="checkbox" /> {t("Kazakh required")}</label>
                        </div>
                    </div>

                    {/* Work schedule */}
                    <div className="uk-width-1-2@m">
                        <label className="uk-form-label">{t("Start Time")}</label>
                        <div className="uk-form-controls">
                            <input className="uk-input" type="time" />
                        </div>
                    </div>
                    <div className="uk-width-1-2@m">
                        <label className="uk-form-label">{t("End Time")}</label>
                        <div className="uk-form-controls">
                            <input className="uk-input" type="time" />
                        </div>
                    </div>

                    {/* Address and city */}
                    <div className="uk-width-1-1">
                        <label className="uk-form-label">{t("Address and City")}</label>
                        <div className="uk-form-controls">
                            <input className="uk-input" type="text" placeholder={t("Enter address and city")} />
                        </div>
                    </div>

                    {/* Benefits */}
                    <div className="uk-width-1-1 uk-form-controls uk-form-controls-text">
                        <label><input className="uk-checkbox" type="checkbox" /> {t("Transport provided by company")}</label><br/>
                        <label><input className="uk-checkbox" type="checkbox" /> {t("Meals provided by company")}</label>
                    </div>

                    {/* Submit button */}
                    <div className="uk-width-1-1 uk-text-center uk-margin-top">
                        <button className="uk-button uk-button-primary" type="submit">{t("Submit")}</button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default PostJobPage;
